<!-- 修改报价弹框 -->
<template>
    <el-dialog append-to-body title="修改报价" :visible.sync="centerDialogVisible" width="30%" center>
        <div class="box">
            <p>成本：<span>{{ datas.price }}</span>{{ datas.currency }}</p>
            <p>报价： <el-input size="mini" class="input1" style="width: 1.3rem;font-size: 0.2rem;" v-model="newPrice"
                    type="number"></el-input>{{
                        datas.currency }}</p>
            <p>利润：<span>{{ profit }}</span> {{ datas.currency }}</p>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            centerDialogVisible: false,
            newPrice: null,
            datas: {},
        }
    },
    computed: {
        profit() {
            return (Number(this.newPrice) - this.datas.price).toFixed(2)
        },
    },
    watch: {},
    methods: {
        initClick(val) {
            this.newPrice = val.toCPrice
            this.datas = val
            this.centerDialogVisible = true
        },
        save() {
            this.$confirm('您确定修改报价?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                this.$emit('updatePrice',this.newPrice,this.datas.stockPriceId)
                this.centerDialogVisible = false
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '修改失败'
                });
            });
        }
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
/deep/ .input1 .el-input__inner {
    color: #CB582E;
}

.box {
    display: flex;
    justify-content: space-around;

    p {
        font-size: 0.2rem;

        span {
            color: #CB582E;
        }
    }
}
</style>